import React, { memo } from 'react'
import { useHistory } from 'react-router-dom'
import { Button, Grid, Theme, useMediaQuery } from '@mui/material'
import { translate } from '../i18n'
import { FormActionsProps } from './FormActions.types'

function FormActions({
    id,
    type = 'submit',
    mainAction = translate(id ? 'buttons.update' : 'buttons.add'),
    cancelAction = translate('buttons.cancel'),
    disabled,
    mt = 2,
    onClick,
    onCancel,
}: FormActionsProps) {
    const history = useHistory()
    const isXs = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'))

    return (
        <Grid item xs={12}>
            <Grid
                container
                justifyContent="flex-start"
                spacing={1}
                direction="row-reverse"
                sx={{ mt: mt }}
            >
                <Grid item xs={12} sm="auto">
                    <Button
                        type={type}
                        variant="contained"
                        color="primary"
                        size="large"
                        fullWidth={isXs}
                        disabled={disabled}
                        onClick={onClick}
                    >
                        {mainAction}
                    </Button>
                </Grid>
                <Grid item xs={12} sm="auto">
                    <Button
                        variant="text"
                        color="inherit"
                        size="large"
                        onClick={onCancel ?? history.goBack}
                        fullWidth={isXs}
                    >
                        {cancelAction}
                    </Button>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default memo(FormActions)
